// src/services/api.js
import axios from 'axios';

// Define the base URL for the API
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Create an axios instance
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    // Don't include credentials by default since the server doesn't support it
    withCredentials: false,
});

// Add response interceptor for error handling
apiClient.interceptors.response.use(
    response => response,
    error => {
        // Check if error is due to authentication issues
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            console.error('Authentication error in API call:', error.response.status);

            // Redirect to auth page on 401/403 errors
            if (window.location.pathname !== '/auth') {
                // Store the current path to redirect back after login
                const currentPath = window.location.pathname;
                if (currentPath && currentPath !== '/auth') {
                    sessionStorage.setItem('authRedirectPath', currentPath);
                }

                // Redirect to auth page
                window.location.href = '/auth';
            }
        }
        return Promise.reject(error);
    }
);

// API service functions
const ApiService = {
    // Financial runway endpoints
    getStatus: () => apiClient.get('/api/v2/status'),
    getRunway: () => apiClient.get('/api/v2/runway'),
    getProjection: () => apiClient.get('/api/v2/projection'),

    // Fun money endpoints
    getFunMoneyBalances: () => apiClient.get('/api/v2/fun-money/balances'),
    getFunMoneySettings: () => apiClient.get('/api/v2/fun-money/settings'),
    updateFunMoneySettings: (settings) => apiClient.post('/api/v2/fun-money/settings', settings),
    addFunMoneyTransaction: (transaction) => apiClient.post('/api/v2/fun-money/add-transaction', transaction),

    // Spending analysis endpoints
    getDiscretionarySpending: () => apiClient.get('/api/v2/spending/discretionary'),

    // Monarch Money direct endpoints
    getPendingTransactions: () => apiClient.get('/api/transactions/pending'),
    refreshData: () => apiClient.post('/api/refresh'),
};

export default ApiService;